/** The slice fields the upload paths use to attribute a file to a user. */
export interface AuthIdentity {
  isAuthenticated?: boolean;
  userId?: string | null;
  userEmail?: string | null;
}

/**
 * The username stamped onto uploads. Supports both MSAL and custom auth: the
 * MSAL account id where we have one, the email otherwise. Unauthenticated local
 * development has neither, hence the placeholder.
 */
export function getCurrentUserId(auth: AuthIdentity | null | undefined): string {
  if (auth?.isAuthenticated && auth.userId) {
    return auth.userId;
  }
  if (auth?.isAuthenticated && auth.userEmail) {
    return auth.userEmail;
  }
  return "test.user";
}
